import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { compose, lifecycle, withHandlers, withState } from 'recompose';
import logoImg from 'assets/img/logo.png';
import Cart from './Cart';
import MenuItem from './MenuItem';

import './style.scss';

const Header = ({ cart, activeTab }) => (
  <div className="header">
    <div className="header__warning">
      Уважаемые клиенты, в настоящий момент интернет-магазин работает в тестовом режиме. Оформление заказов временно недоступно.
    </div>
		<div className="header__inner">
      <Link to="/" className="header__logo">
        <img src={logoImg} alt="Ярославская трикотажная фабрика" />
        <div className="header__logo__text">
          <span className="header__logo__caption">ThermoTour</span>
          <span>термобелье от</span>
          <span>производителя</span>
        </div>
      </Link>
      <div className="header__menu">
        <MenuItem text="Каталог" anchor="catalog" activeItem={activeTab} />
        <MenuItem text="Доставка" anchor="delivery" activeItem={activeTab} />
        <MenuItem text="Контакты" anchor="contacts" activeItem={activeTab} />
      </div>
			<Cart cart={cart} />
		</div>
  </div>
);

Header.propTypes = {
  activeTab: PropTypes.string,
  cart: PropTypes.object.isRequired,
};

export default compose(
  withState('activeTab', 'toggleActiveTab', ''),
  withHandlers({
    checkActiveTab: ({ toggleActiveTab, currentRoute }) => () => {
      if (currentRoute.includes('delivery')) {
        toggleActiveTab('delivery');
      } else if (currentRoute.includes('catalog') || currentRoute.includes('product')) {
        toggleActiveTab('catalog');
      } else if (currentRoute.includes('contacts')) {
        toggleActiveTab('contacts');
      } else {
        toggleActiveTab('');
      }
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.checkActiveTab();
    },
    componentWillReceiveProps(nextProps) {
      if (this.props.currentRoute !== nextProps.currentRoute) {
        this.props.checkActiveTab();
      }
    },
  }),
)(Header);



// WEBPACK FOOTER //
// ./src/components/ui/Header/index.js